import React from "react";

// interface useMobileProps {}

//React hook determines if the user is on a mobile device
const useMobile: () => boolean = () => {
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    const userAgent = navigator.userAgent;
    const isMobile = Boolean(
      userAgent.match(
        /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i
      ) || window.innerWidth < 768
    );
    setIsMobile(isMobile);
  }, []);

  return isMobile;
};
export default useMobile;
